<template>
	<div>
		<vs-table search stripe :data="clients" max-items="5" pagination>
			<template slot="header">
				<h1>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
						Proveedores<br>
					</vs-col>
					<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
						<vs-button @click="createClientPrompt()" radius color="success" type="border" icon="add"></vs-button>
					</vs-col>
					<vs-prompt @cancel="val=''" @accept="createClient" :active.sync="activePrompt2" title="Crear Cliente" :is-valid="validName">
						<div class="con-exemple-prompt">
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
								<img :src="logo" class="uploading-image" />
								<vs-input size="small" type="file" label="Logo"  @change=uploadImage accept="image/*"/>
								<vs-input size="small" label="Contraseña" v-model="password" type="password"/>
								<vs-alert :active="!validName" color="danger" icon="new_releases" class="emptyWarning">
									Completar campos
								</vs-alert>
							</vs-col>
							<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >							
								<vs-input size="small" label="Nombre" v-model="name"/>
								<vs-input size="small" label="Dirección" v-model="address"/>
								<vs-input size="small" label="RTN" v-model="rtn"/>
								<vs-input size="small" label="CAI" v-model="cai"/>
								<vs-input size="small" label="Teléfono" v-model="phone"/>
								<vs-input size="small" label="Email" v-model="email"/>
								<vs-input size="small" label="Observación" v-model="observation"/>
							</vs-col>
						</div>
					</vs-prompt>
					
				</h1>
			</template>
			<template slot="thead">
				<vs-th>
					Nombre
				</vs-th>
				<vs-th>
					Teléfono
				</vs-th>
				<vs-th>
					Email
				</vs-th>
				<vs-th>
					Observación
				</vs-th>
				<vs-th>
					Editar
				</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :state="indextr == 1 ?'success':indextr == 3?'success':null" :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].name">
						{{data[indextr].name}}
						<!-- <template slot="edit">
							<vs-input v-model="data[indextr].name" class="inputx" placeholder="Nombre"/>
						</template> -->
					</vs-td>

					<vs-td :data="data[indextr].phone">
						{{data[indextr].phone}}
					</vs-td>

					<vs-td :data="data[indextr].email">
						{{data[indextr].email}}
					</vs-td>

					<vs-td :data="data[indextr].observation">
						{{data[indextr].observation}}
					</vs-td>

					<vs-td :data="data[indextr].id">
						<vs-button  @click="editClientPrompt(tr)" vs-type="gradient" size="small" color="success" icon="edit"></vs-button>
						<vs-prompt @cancel="val=''" @accept="editClient" :active.sync="activePrompt" title="Editar Cliente">
							<div class="con-exemple-prompt">
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >
									<img :src="logo" class="uploading-image" />
									<vs-input size="small" type="file" label="Logo"  @change=uploadImage accept="image/*"/>
									<vs-input size="small" label="Contraseña" v-model="password" type="password"/>
									<vs-input size="small" label="Observación" v-model="observation"/>
								</vs-col>
								<vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6" >							
									<vs-input size="small" label="Nombre" v-model="name"/>
									<vs-input size="small" label="Dirección" v-model="address"/>
									<vs-input size="small" label="RTN" v-model="rtn"/>
									<vs-input size="small" label="CAI" v-model="cai"/>
									<vs-input size="small" label="Teléfono" v-model="phone"/>
									<vs-input size="small" label="Email" v-model="email"/>
								</vs-col>
							</div>
						</vs-prompt>
					</vs-td>
					<!-- <vs-td :data="data[indextr].created_at">
						{{ getHumanDate(data[indextr].created_at) }} 
					</vs-td> -->
					<template class="expand-user" slot="expand">
							<vs-list>
								<vs-list-item :title="tr.name" subtitle="Empresa">
									<template slot="avatar">
										<vs-avatar size="45px" :src="`${tr.logo}`"/>
									</template>
								</vs-list-item>
								<vs-list-item icon="place" title="Dirección" :subtitle="tr.address"></vs-list-item>
								<vs-list-item icon="work" title="RTN" :subtitle="tr.rtn"></vs-list-item>
								<vs-list-item icon="clear_all" title="CAI" :subtitle="tr.cai"></vs-list-item>

							</vs-list>
							<div class="con-btns-user">
								<div>
									<vs-button @click="openConfirm(tr.id, tr.name)" vs-type="flat" size="medium" color="danger" icon="delete_sweep"></vs-button>
								</div>
							</div>
					</template>
				</vs-tr>
			</template>

    </vs-table>
	<pre>{{ selected }}</pre>

	</div>
</template>

<script>

import moment from 'moment';

export default {
	data(){
		return{
			clients : [],
			val:'Cliente',
			activePrompt:false,
			activePrompt2:false,
			activeConfirm:false,
			idClient: 0,
			name: "",
			address: "",
			cai: "",
			rtn: "",
			phone: "",
			email: "",
			password: "",
			observation: "",
			logo:"",
			logoData:"",
			config:"",
			flag: false,
		}
	},
	computed:{
		validName(){
			return (this.name.length > 0 && this.address.length > 0 && this.cai.length > 0 && this.rtn.length > 0 && this.phone.length > 0 && this.email.length > 0 && this.password.length > 0 && this.observation.length > 0 && this.logo.length > 0)
		}
	},
	methods: {
		getClients(){
			const path = '/provider/'
			this.$http.get(path).then((response) => {
				this.clients = response.data
				console.log(this.clients)
			})
			.catch((error) => {
				console.log(error)
			})
		},
		editClient(){
			const path = `/provider/${this.idClient}/` 
			this.$http.patch(path, {
				name: this.name,
				address: this.address,
				cai: this.cai,
				rtn: this.rtn,
				phone: this.phone,
				email: this.email,
				password: this.password,
				observation: this.observation,
			})
			.then((response) => {
				console.log(response.data)
				this.getClients()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:'Actualización de los datos del cliente'
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser editado'
				})
			});
			if(this.flag){
				this.flag = false;
				this.$http.patch(path, 
					this.logoData,
					this.config
				)
				.then((response) => {
					console.log(response.data)
					this.getClients()
					this.$vs.notify({
						color:'success',
						title:'Imagen subida exitósamente',
						text:'Actualización del logo del cliente'
					})	
				})
				.catch((error) => {
					console.log(error)
					this.$vs.notify({
						color:'danger',
						title:'ERROR',
						text:'La imagen no pudo ser subida'
					})
				})
			}	
		},
		deleteClient(){
			const path = `/provider/${this.idClient}/` 
			this.$http.delete(path).then((response) => {
				console.log(response.data)
				this.getClients()
				this.$vs.notify({
					color:'danger',
					title:'Registro eliminado',
					text:`El registro fue eliminado correctamente`
				})
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El registro no pudo ser eliminado'
				})
			})
			
		},
		createClient(){
			const path = `/provider/`
			this.flag = false;
			this.logoData.append('name', this.name);
			this.logoData.append('address', this.address);
			this.logoData.append('cai', this.cai);
			this.logoData.append('rtn', this.rtn);
			this.logoData.append('phone', this.phone);
			this.logoData.append('email', this.email);
			this.logoData.append('password', this.password);
			this.logoData.append('observation', this.observation);
			
			this.$http.post(path, this.logoData)
			.then((response) => {
				console.log(response.data)
				this.getClients()
				this.$vs.notify({
					color:'success',
					title:'Cambios realizados exitósamente',
					text:`Creación del cliente ${this.name}`
				})	
			})
			.catch((error) => {
				console.log(error)
				this.$vs.notify({
					color:'danger',
					title:'ERROR',
					text:'El cliente no pudo ser creado'
				})
			});
		},
		openConfirm(id, c){
			this.idClient = id,
			this.$vs.dialog({
				type:'confirm',
				color: 'danger',
				title: `Confirmar`,
				text: `¿Desea eliminar al cliente ${c}?`,
				accept:this.deleteClient,
				acceptText:'Aceptar',
				cancelText:'Cancelar',
			})
		},
		editClientPrompt(id){
			this.idClient = id["id"];
			this.activePrompt = true;
			this.name= id["name"];
			this.address= id["address"];
			this.cai= id["cai"];
			this.rtn= id["rtn"];
			this.phone= id["phone"];
			this.email= id["email"];
			this.password= id["password"];
			this.observation= id["observation"];
			this.logo= id["logo"];	
			this.flag= false;	
		},
		createClientPrompt(){
			this.idClient = "";
			this.activePrompt2 = true;
			this.name= "";
			this.address= "";
			this.cai= "";
			this.rtn= "";
			this.phone= "";
			this.email= "";
			this.password= "";
			this.observation= "";
			this.logo= "";	
			this.flag= false;	
		},
		uploadImage(e){
			const image = e.target.files[0];
			
			const reader = new FileReader();
			reader.readAsDataURL(image);
			reader.onload = e =>{
				this.logo = e.target.result;
				console.log(this.logo);
			};
			this.flag = true;
			this.logoData = new FormData();
			this.logo = event.target.files[0];
			this.logoData.append('logo', this.logo);

			this.config = {
				header : {
					'Content-Type' : 'image/png'
				}
			}
		},
		getHumanDate : function (date) {
			// return moment(date, 'YYYY-MM-DDTh:mm').format('DD/MM/YYYY, h:mm a');
			moment.locale('es');
			return moment(date, 'YYYY-MM-DDTh:mm').fromNow();
		},
	},
	created(){
		this.getClients()
	}
}
</script>

<style lang="stylus">
.con-exemple-prompt
	padding 1px;
	padding-bottom 1px;
	.vs-input
		width 90%
		margin-top 1px;
.uploading-image{
	max-width: 50%;
	max-height: 108px;
	border-radius: 8px;
	margin-top: 10px;
	margin-left: 20%;
}
.emptyWarning{
	width 90%;
	margin-top:10px;
}
</style>